// @flow
import React, { useState } from 'react';
// Components
import { InstantSearch } from 'react-instantsearch-dom';
import WishlistProductModal from '../components/wishlist/WishlistProductModal';
// Typesense
import { searchClient } from '../../search/typesenseAdapter';

type Props = {
  isOpen: boolean,
  handleClose: () => void,
};

const WishlistModal = ({ isOpen, handleClose }: Props) => {
  const [searchState, setSearchState] = useState({ query: '' });
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={
        process.env.REACT_APP_TYPESENSE_PRODUCT_INDEX ||
        'product_sales_production'
      }
      searchState={searchState}
      onSearchStateChange={setSearchState}
    >
      <WishlistProductModal isOpen={isOpen} handleClose={handleClose} />
    </InstantSearch>
  );
};

export default WishlistModal;
